var _defs, _g, _rect, _path, _path2, _rect2, _path3, _path4, _rect3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgElcosLogoColorWoSrlV1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 804.89 172.28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-3,.cls-5{fill:#bb2218;}.cls-1{stroke:#1a1719;}.cls-1,.cls-3{stroke-miterlimit:22.93;stroke-width:0.29px;}.cls-2,.cls-4{fill:#1a1719;}.cls-3{stroke:#bb2218;}.cls-4{isolation:isolate;font-size:60.81px;font-family:Arial-BoldItalicMT, Arial;font-weight:700;font-style:italic;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ELCOS_logo_woSrl-01") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g3877"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3027",
    className: "cls-1",
    d: "M123.5,85.74H9.59v76.41H123.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3031",
    className: "cls-2",
    d: "M4.35,5.7H127.9v162H4.35Zm81.75,67-40-.09V19.83h40V26.9H63.56V46.31H86.1v7.07H63.56V65.64H86.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3033",
    className: "cls-3",
    d: "M86.28,19.3v7.35H64.17V45.83H86.28l-.09,7.57-22.34.09V65.34H86.28v7.35l-40.06-.32L46.13,19.7Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g66"
  }, /*#__PURE__*/React.createElement("g", {
    id: "text3023"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(746.21 58.02)"
  }, "\xAE")), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "307.29 7.53 259.57 7.53 259.57 162.58 348.1 162.58 348.1 138.43 307.29 138.43 307.29 7.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M409.3,138.43V31.68c17.12,0,26.28,5.42,40.81,17.32l13.66-17.32h0C412.76-19.95,331,21.35,331,80c0,61.95,64.66,117.08,132.79,58.45L450.13,121.3A55.89,55.89,0,0,1,409.3,138.43Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "157.39 162.58 245.91 162.58 245.91 138.43 205.1 138.43 205.1 107.45 245.91 107.45 245.91 83.31 205.1 83.31 205.1 31.68 245.91 31.68 245.91 7.53 157.39 7.53 157.39 162.58"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M526.87,7.53c-42,0-76.42,34.82-76.42,77.53s34.41,77.52,76.42,77.52,76.43-34.82,76.43-77.52S568.89,7.53,526.87,7.53Zm-.17,134.35L525.44,30.2c34.06,0,54,22.13,54,56.6S557.31,141.88,526.7,141.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M712.4,100.28,655.34,36.93a4.34,4.34,0,0,1,1.38-5.6c10.89-4,19.54-.35,29,3.5,9.51,4.9,14,8.4,22.48,15.93l12.62-16.11C701.45,13.13,683,5.65,653,7.53c-18.84,3-35.1,12.07-46.51,25.2-6.91,10.67-6.91,19.42,1.56,32l55,62c6.39,4.9,8.13,11.55,2.42,12.6a74.3,74.3,0,0,1-10.55-.18c-13.14-2.45-24.21-11.2-33.71-19.78l-15.91,16.28c13.66,15.23,25.59,21.7,44.26,26.08,25.07,4,56.34-5.36,69.09-22.79S723.46,111.66,712.4,100.28Z"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 10.59,
    y: 87.08,
    width: 111.74,
    height: 74.76
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M87,97.16c1.87.55,2.31,1.54,1.6,4.06l-1.78,5.22,3.39.09v3.61H85.67l-1.25,3.51h5.79v3.6h-7c-2.5,7.21-6.06,17.12-8.55,24.15,6.76,7.29,2,14.59-1.87,17-6.23,3-12.81.72-15.48-6-2.41-6.93,3.91-15,11.84-14,3.73-10.18,9.34-28.37,13.17-38.64,1.42-3.15,2.49-3.52,4.71-2.71Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M67.34,92.39a10.63,10.63,0,1,1-10.59,10.67V103A10.65,10.65,0,0,1,67.34,92.39Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 90.22,
    y: 99.51,
    width: 24.47,
    height: 24.77
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M67.25,145.72a3.47,3.47,0,1,1-3.38,3.56v-.14A3.48,3.48,0,0,1,67.25,145.72Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M67.17,99.6a3.47,3.47,0,1,1-3.39,3.55V103A3.47,3.47,0,0,1,67.17,99.6Z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 97.25,
    y: 106.62,
    width: 10.5,
    height: 10.63
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElcosLogoColorWoSrlV1);
export default __webpack_public_path__ + "static/media/ELCOS_logo_color_woSrl_v1.7147203c683819252b99bb2c2c64cf96.svg";
export { ForwardRef as ReactComponent };